/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLocationModifiers200ResponseItemsInner } from './GetLocationModifiers200ResponseItemsInner';
import {
    GetLocationModifiers200ResponseItemsInnerFromJSON,
    GetLocationModifiers200ResponseItemsInnerFromJSONTyped,
    GetLocationModifiers200ResponseItemsInnerToJSON,
    GetLocationModifiers200ResponseItemsInnerToJSONTyped,
} from './GetLocationModifiers200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetLocationModifiers200Response
 */
export interface GetLocationModifiers200Response {
    /**
     * 
     * @type {Array<GetLocationModifiers200ResponseItemsInner>}
     * @memberof GetLocationModifiers200Response
     */
    items: Array<GetLocationModifiers200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetLocationModifiers200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetLocationModifiers200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetLocationModifiers200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the GetLocationModifiers200Response interface.
 */
export function instanceOfGetLocationModifiers200Response(value: object): value is GetLocationModifiers200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function GetLocationModifiers200ResponseFromJSON(json: any): GetLocationModifiers200Response {
    return GetLocationModifiers200ResponseFromJSONTyped(json, false);
}

export function GetLocationModifiers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationModifiers200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetLocationModifiers200ResponseItemsInnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function GetLocationModifiers200ResponseToJSON(json: any): GetLocationModifiers200Response {
    return GetLocationModifiers200ResponseToJSONTyped(json, false);
}

export function GetLocationModifiers200ResponseToJSONTyped(value?: GetLocationModifiers200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetLocationModifiers200ResponseItemsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

